import React from "react";

import { APIPost, APIGet } from "services/APIRequest"
import UrlServer from "configs/UrlServer"

import ConfigHost from "services/ConfigHost"

import { ErrorsCallback, SuccessCallback } from "alertService"

class PageRedirection extends React.Component {
  componentDidMount() {
    console.log(this.props.match.params.code)
    var dataToSend = {
      uniqcode: this.props.match.params.code
    }
    APIPost(UrlServer.URL_POST_QUESTION_CONVERT_CODE_TO_ID2, dataToSend, (datas) => {
      if (datas.datas !== "" && datas.datas != undefined && datas.datas != null) {
        window.location = ConfigHost.MY_APP_PUBLIC_IP + "survey/pr/" + datas.datas + "/th";
      } else {
        ErrorsCallback(datas.message, () => {

        })
      }
    })
    // window.location = "http://localhost:3000/survey/pr/5ec646d435857405005cecc8/th";
  }
  render() {
    const { classes } = this.props;
    return (
      <center>
        <h3> {this.props.match.params.code} </h3>
        <h5>Redirection... Loading...</h5>
      </center>
    );
  }
}

export default PageRedirection;
